const encoder = new TextEncoder()

/**
 * Converts a string to a Uint8Array using UTF-8 encoding.
 *
 * @param value - The string to convert
 * @returns A Uint8Array containing the UTF-8 encoded bytes
 *
 * @example
 * ```ts
 * import { StringToUInt8 } from "@pdfking/tfunc"
 *
 * const bytes = StringToUInt8("Hello");
 * console.log(bytes); // Uint8Array [72, 101, 108, 108, 111]
 *
 * // Use for hashing
 * const hash = await UInt8Hash([StringToUInt8("my-data")]);
 * ```
 */
export const StringToUInt8 = (value: string): Uint8Array =>
  encoder.encode(value)
